
import req from '../utils/request.js'

const collapi = {}

// 搜索用户侧边栏
collapi.searchUserMenu = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/getUserTypeList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
//  搜索资源侧边栏
collapi.searchFileMenu = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/resourceLeftMenu', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 搜索用户
collapi.searchUser = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/adks-app/pc/apiv1/home/homeSearchUser', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 搜索馆藏
collapi.searchColl = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/adks-app/pc/apiv1/home/homeSearch', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏详情
collapi.detail = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/collectionInfo', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 举报
collapi.report = function(params) {
  return new Promise((resolve, reject) => {
    // req.postdata('/complaintrecord/save', params).then(res => {
    req.postdata('/adks-app/complaintrecord/save', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 搜索关键词关联的筛选项
collapi.keyMemu = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getSumNavigation', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 纪事地点分页加载
collapi.regionPage = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getRegionNavigation', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 纪事人物分页加载
collapi.personPage = function(params) {
  let url = '/adks-app/pc/apiv1/collection/getFigureNavigation'
  if (params.type === 'resource') {
    url = '/adks-app/pc/apiv1/collection/resourceDocumentaryMan'
  }
  return new Promise((resolve, reject) => {
    req.get(url, params.data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取发布人
collapi.pubmanPages = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getPublisherNavigation', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取发布时间
collapi.getReleasedate = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getReleasedate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取纪实人物
collapi.getFigureNavigation = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getFigureNavigation', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取纪实年份
collapi.getChronicleDate = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/getChronicleDate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 发布人分页加载
collapi.pubmanPage = function(params) {
  let url = '/adks-app/pc/apiv1/collection/getPublisherNavigation'
  if (params.type === 'resource') {
    url = '/adks-app/pc/apiv1/collection/publisherMenu'
  }
  return new Promise((resolve, reject) => {
    req.get(url, params.data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 纪事年份分页加载
collapi.datePage = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/getChronicleDate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 专题分页加载
collapi.topicPage = function(params) {
  let url = '/adks-app/pc/apiv1/collection/specialSubject'
  if (params.type === 'resource') {
    url = '/adks-app/pc/apiv1/collection/resourceTopicPage'
  }
  return new Promise((resolve, reject) => {
    req.get(url, params.data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 发布日期分页加载
collapi.pubdatePage = function(params) {
  let url = '/adks-app/pc/apiv1/collection/getReleasedate'
  if (params.type === 'resource') {
    url = '/adks-app/pc/apiv1/collection/releaseDate'
  }
  return new Promise((resolve, reject) => {
    req.get(url, params.data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 资源创作日期分页加载
collapi.createDatePage = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/resourceCreationDate', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 资源搜索
collapi.searchResource = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/adks-app/pc/apiv1/home/homeSearchResource', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 资源搜索
collapi.searchResource = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/adks-app/pc/apiv1/home/homeSearchResource', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 播放时长
collapi.statistics = function(params) {
  console.log(params)
  return new Promise((resolve, reject) => {
    req.postdata('/adks-app/pc/apiv1/collection/addSave', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 检查IP是否在范围内
collapi.ip = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/collection/ipPermissions', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default collapi
